import request from '@/utils/request'

// 查询列表
export function apiBomWorkshopList (query) {
  return request({
    url: '/bom/bomWorkshop/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiBomWorkshopNewExport (data) {
  return request({
    url: '/bom/bomWorkshop/v2/export',
    method: 'post',
    data: data
  })
}

// 修改
export function apiBomWorkshopUpdate (data) {
  return request({
    url: '/bom/bomWorkshop',
    method: 'put',
    data: data
  })
}

// 新增
export function apiBomWorkshopAdd (data) {
  return request({
    url: '/bom/bomWorkshop',
    method: 'post',
    data: data
  })
}

// 默认工单分类
export function apiJobClassPullDownList (query) {
  return request({
    url: '/mes/jobClass/pullDownList',
    method: 'get',
    params: query
  })
}

// 车间编码
export function apiBomWorkshopFindList (query) {
  return request({
    url: '/bom/bomWorkshop/findList',
    method: 'get',
    params: query
  })
}
